import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SearchScreen from './SearchScreen';
import ItemListScreen from './ItemListScreen';
import ItemDetailsScreen from './ItemDetailsScreen';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SearchScreen />} />
        <Route path="/items" element={<ItemListScreen />} />
        <Route path="/item/:id" element={<ItemDetailsScreen />} />
      </Routes>
    </Router>
  );
}

export default App;
